import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../shared/services/auth.service';
import {SubscriptionService} from '../../../shared/services/subscription.service';
import {RegistrationSubscriptionService} from '../../../shared/services/registration-subscription.service';
import {properties} from '../../../../environments/properties';
import {_windowUtil} from '../../../shared/utils/ui-utils';

// jQuery
declare let $: any;

@Component({
    selector: 'app-partners-landing',
    templateUrl: './partners-landing.component.html',
    styleUrls: ['./partners-landing.component.scss'],
    providers: [SubscriptionService, RegistrationSubscriptionService],
})
export class PartnersLandingComponent implements OnInit {
    public discountCode: string;
    public loading: boolean = true;
    public partnerName?: string;
    public partnerLogo?: string;
    public heading?: string;
    public name?: string;
    public discountPrice?: string;
    public regularFee?: string;
    public currentEnvironment: string;
    public userInfo: any;
    public isLoggedInTokenValid: boolean = false;
    public enablePartners: boolean;
    public params?: URLSearchParams;
    logoAltText: string = 'Freshpass logo';
    frequentlyAskedQuestion;
    termsContent;
    showFrequentlyAskedQuestion = false;
    showTermsContent = false;
    partnersData: any;
    description?: string;
    isAPIError = false;
    errorMessage = {};
    public windowUtil = _windowUtil(window);
    public discountPayload: any;
    properties = properties;

    ERROR_DISCOUNT_TITLE = properties.partnersLanding.ERROR_DISCOUNT_TITLE;
    ERROR_DISCOUNT_MESSAGE = properties.partnersLanding.ERROR_DISCOUNT_MESSAGE;

    ERROR_MISSING_BANNERS_TITLE = properties.partnersLanding.ERROR_MISSING_BANNERS_TITLE;
    ERROR_MISSING_BANNERS_MESSAGE = properties.partnersLanding.ERROR_MISSING_BANNERS_MESSAGE;

    DISCOUNT_ERROR = properties.partnersLanding.DISCOUNT_ERROR;
    BANNER_ERROR = properties.partnersLanding.BANNER_ERROR;

    constructor(
        public subscriptionService: SubscriptionService,
        public registrationSubscriptionService: RegistrationSubscriptionService,
        public authService: AuthService
    ) {
    }

    ngOnInit(): void {
        this.enablePartners = properties.featureFlags.enablePartners;
        this.currentEnvironment = this.subscriptionService.getEnvironment();
        if (this.enablePartners) {
            this.getUserInfo();
        } else {
            this.windowUtil.setWindowLocationHref('/freshpass/manage/subscribe');
        }

    }

    getUserInfo() {
        this.authService.getUserLogedInToken();
        this.authService.populateSessionData$.subscribe((userInfo) => {
            if (userInfo) {
                this.userInfo = userInfo;
                if (userInfo.isTokenValid) {
                    this.isLoggedInTokenValid = true;
                }
                if (!this.params) {
                    this.params = new URLSearchParams(window.location.search);
                }
                if (this.params.has('discountCode')) {
                    this.discountCode = this.params.get('discountCode');
                    this.subscriptionService
                        .getPartnerData(this.discountCode, this.currentEnvironment, this.userInfo)
                        .subscribe((data) => {
                          this.loading = false;
                          if (data?.discountPayload?.banners) {
                            this.partnersData = data;
                            this.discountPayload = data.discountPayload;
                            this.discountPrice = `$${data.planPrice.toFixed(2)}`;
                            this.regularFee = `$${data.regularPlanPrice}`;
                            this.partnerName = this.discountPayload.partnerName;
                            this.partnerLogo = this.discountPayload.partnerLogo;
                            this.heading = this.discountPayload.heading.replace(' <fee>', '')
                            this.description = this.discountPayload.description;
                            this.partnerName = this.discountPayload.partnerName;
                            if (data.discountPayload.faq) {
                                this.showFrequentlyAskedQuestion = true;
                                this.frequentlyAskedQuestion = data.discountPayload.faq
                            }
                            if (data.discountPayload.terms) {
                                this.showTermsContent = true;
                                this.termsContent = data.discountPayload.terms
                            }
                          } else {
                            this.handleError(this.BANNER_ERROR)
                          }
                        },
                            (err => {
                                if (err) {
                                    if (err.error && err.error.errorCode) {
                                        this.handleError(err.error)
                                    }
                                }
                            }));
                } else {
                  this.handleError(this.DISCOUNT_ERROR);
                }
            }
        });
    }

    handleError(error) {
      this.loading = false;
      this.isAPIError = true;
      if (error === this.DISCOUNT_ERROR || error === this.BANNER_ERROR) {
        this.setErrorMessage(error)
      } else {
        switch(error.errorCode) {
          case this.DISCOUNT_ERROR:
            this.setErrorMessage(this.DISCOUNT_ERROR);
            break;
          case this.BANNER_ERROR:
            this.setErrorMessage(this.BANNER_ERROR);
            break
          case "OSMS-SUBSCRIPTION-00047":
            this.setErrorMessage(this.DISCOUNT_ERROR);
            break;
          default:
            this.setErrorMessage(this.BANNER_ERROR);
            break;
        }
      }
    }

    setErrorMessage(error) {
      if (this.DISCOUNT_ERROR) {
        this.errorMessage = {
          title: this.ERROR_DISCOUNT_TITLE,
          message: this.ERROR_DISCOUNT_MESSAGE
        }
      } else {
        this.errorMessage = {
          title: this.ERROR_MISSING_BANNERS_TITLE,
          message: this.ERROR_MISSING_BANNERS_MESSAGE
        }
      }
    }
    
    isUserAuthorized() {
        return this.isLoggedInTokenValid;
    }
}
